<template>
  <div v-if="complete">
    <a class="group">
      <span class="flex items-start">
        <span class="relative flex h-5 w-5 flex-shrink-0 items-center justify-center">
          <CheckCircleIcon class="h-full w-full text-teal-600 group-hover:text-teal-800" aria-hidden="true" />
        </span>
        <span class="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900">
          <slot/>
        </span>
      </span>
    </a>
  </div>
  <div v-else-if="current">
    <a class="flex items-start" aria-current="step">
      <span class="relative flex h-5 w-5 flex-shrink-0 items-center justify-center" aria-hidden="true">
        <span class="absolute h-4 w-4 rounded-full bg-teal-200" />
        <span class="relative block h-2 w-2 rounded-full bg-teal-600" />
      </span>
      <span class="ml-3 text-sm font-medium text-teal-600">
        <slot/>
      </span>
    </a>
  </div>
  <div v-else-if="pending">
    <div class="flex items-start">
      <div class="relative flex h-5 w-5 flex-shrink-0 items-center justify-center" aria-hidden="true">
        <div class="h-2 w-2 rounded-full bg-gray-300 group-hover:bg-gray-400" />
      </div>
      <p class="ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900">
        <slot/>
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const STATUS_CURRENT = 'current';
const STATUS_COMPLETE = 'complete';
const STATUS_PENDING = 'pending';
const props = defineProps({status: String});
const current = computed(() => props.status === STATUS_CURRENT);
const complete = computed(() => props.status === STATUS_COMPLETE);
const pending = computed(() => props.status === STATUS_PENDING);
</script>

